import { NgModule } from '@angular/core';
import { HideHeaderDirective } from './hide-header/hide-header';
import { NumberInputDirective } from './number-input/number-input.directive';
import { ScrollHideDirective } from './hide-header2/hide-header2';
import { AbsoluteDragDirective } from './absolute-drag/absolute-drag';

@NgModule({
	declarations: [
		HideHeaderDirective,
		NumberInputDirective,
		ScrollHideDirective,
    AbsoluteDragDirective
	],
	imports: [],
	exports: [
		HideHeaderDirective,
		NumberInputDirective,
		ScrollHideDirective,
    AbsoluteDragDirective
	]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts